<template>
  <div class="loading-block" style="position: relative" ref="loadingBlock">
    <template v-if="value === null">
      <span v-if="type === 'string'">-</span>
      <span v-else-if="type === 'money'">￥ -</span>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LoadingBlock',
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: 'string',
      validator (value) {
        return ['image', 'string', 'money'].indexOf(value) !== -1
      }
    }
  },

  data () {
    return {
      loader: null
    }
  },

  computed: {
    isLoading () {
      return typeof this.value === 'undefined'
    }
  },

  watch: {
    isLoading: {
      handler (newVal) {
        if (newVal) {
          this.loader = this.$loading.show({
            container: this.$refs.loadingBlock,
            backgroundColor: 'transparent',
            width: 40,
            height: 40
          })
        } else {
          this.loader && this.loader.hide()
        }
      },
      immediate: false
    }
  },

  mounted () {
    if (this.isLoading && this.$refs.loadingBlock) {
      this.loader = this.$loading.show({
        container: this.$refs.loadingBlock,
        backgroundColor: 'transparent',
        width: 40,
        height: 40
      })
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoadingBlock.vue